module.exports = __webpack_public_path__ + "static/pca-4cb413cb4793466643a23521ea623b6d.png";